import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applySavedPreferences } from "./settings/DisplaySettings";
import { watchForUpdates } from "./update";
// The design system first (ADR-0031): tokens, self-hosted fonts, base rules, components,
// widgets. The app's own additions and screen styles come after and use its tokens.
import "@tutor/ui/tokens.css";
import "@tutor/ui/fonts.css";
import "@tutor/ui/base.css";
import "@tutor/ui/components.css";
import "@tutor/ui/widgets.css";
import "./theme.css";
import "./styles.css";

applySavedPreferences();

const root = document.getElementById("root");
if (root !== null) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Our own service worker (public/sw.js), in production builds only: in development it
// would serve stale modules over Vite's dev server.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // Without it the app still works online; nothing to tell the child.
    });
  });
}

// A window left open picks up a new version when the child comes back to it (update.ts).
if (import.meta.env.PROD) watchForUpdates();
